var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDentalAppointment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 0.75H3.25C1.875 0.75 0.7625 1.875 0.7625 3.25L0.75 20.75C0.75 22.125 1.875 23.25 3.25 23.25H20.75C22.125 23.25 23.25 22.125 23.25 20.75V3.25C23.25 1.875 22.125 0.75 20.75 0.75ZM18.25 14.5H14.5V18.25C14.5 18.9375 13.9375 19.5 13.25 19.5H10.75C10.0625 19.5 9.5 18.9375 9.5 18.25V14.5H5.75C5.0625 14.5 4.5 13.9375 4.5 13.25V10.75C4.5 10.0625 5.0625 9.5 5.75 9.5H9.5V5.75C9.5 5.0625 10.0625 4.5 10.75 4.5H13.25C13.9375 4.5 14.5 5.0625 14.5 5.75V9.5H18.25C18.9375 9.5 19.5 10.0625 19.5 10.75V13.25C19.5 13.9375 18.9375 14.5 18.25 14.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDentalAppointment);
export default __webpack_public_path__ + "static/media/dental_appointment.dfd0bd00ec86f650ace27ae0bc852524.svg";
export { ForwardRef as ReactComponent };